import { INSERT_AND_UPDATE_FRIEGHT_FORWARD_ACTION_TYPE, GET_FRIEGHT_FORWARD_DETAILS_ACTION_TYPE, } from "../../../../../utils/constants";


const initialState = [];

function frieghtForwardReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case INSERT_AND_UPDATE_FRIEGHT_FORWARD_ACTION_TYPE:
            return [...state, payload];
        case GET_FRIEGHT_FORWARD_DETAILS_ACTION_TYPE:
            return [...state, payload];
        default:
            return state;
    }
};

export default frieghtForwardReducer;